import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiBell, FiChevronLeft, FiMenu } from "react-icons/fi";
import { APP_LOGO } from "../config/AppConfig";
import "../assets/css/header.scss";

const pageTitles = {
  "/": "Dashboard",
  "/addProduct": "Add Product",
  "/my-products": "My Product",
  "/categories": "Categories",
  "/profile": "Profile",
};

const Header = ({ isLoggedIn, onToggleSidebar, isSidebarOpen, onLogout }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setIsDropdownOpen(false);
  }, [location.pathname]);

  const handleLogoutClick = () => {
    setIsDropdownOpen(false);
    onLogout?.();
  };

  if (!isLoggedIn) {
    return (
      <header className="site-header site-header--public">
        <div className="container">
          <div className="public-header">
            <Link to="/" className="public-header__brand">
              <img src={APP_LOGO} alt="TechXchange" />
            </Link>
            <div className="public-header__actions">
              <Link className="btn btn-outline-primary" to="/login">
                Log in
              </Link>
              <Link className="btn btn-primary" to="/register">
                Sign up
              </Link>
            </div>
          </div>
        </div>
      </header>
    );
  }

  const currentTitle = pageTitles[location.pathname] || "Dashboard";

  return (
    <header className="site-header site-header--dashboard">
      <div className="dashboard-topbar">
        <div className="dashboard-topbar__left">
          <button className="sidebar-toggle" type="button" onClick={onToggleSidebar} aria-label="Toggle menu">
            {isSidebarOpen ? <FiChevronLeft /> : <FiMenu />}
          </button>

          <div>
            <p className="dashboard-topbar__eyebrow">Control panel</p>
            <h1 className="dashboard-topbar__title">{currentTitle}</h1>
          </div>
        </div>

        <div className="dashboard-topbar__actions">
          {/* <button className="icon-pill" type="button" aria-label="Notifications">
            <FiBell />
          </button> */}

          <div className="account-dropdown" ref={dropdownRef}>
            <button className="account-btn" onClick={() => setIsDropdownOpen((prev) => !prev)} type="button">
              <i className="bi bi-person-circle" />
            </button>

            <div className={`account-menu dropdown-menu ${isDropdownOpen ? "show" : ""}`}>
              <Link className="dropdown-item" to="/profile">
                <i className="bi bi-person" />
                Profile
              </Link>
              <button className="dropdown-item" onClick={handleLogoutClick} type="button">
                <i className="bi bi-box-arrow-right" />
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;